const LANGUAGE_POPUP_STORAGE_KEY = 'trustrental-language-popup-dismissed';

class LanguageArrivalPopup {
  constructor(container) {
    this.container = container;
    this.closeButtons = container.querySelectorAll('[data-language-popup-close]');
    this.forms = container.querySelectorAll('form');
    this.firstFocusableElement = container.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

    this.handleKeydown = this.handleKeydown.bind(this);
    this.close = this.close.bind(this);
    this.markDismissed = this.markDismissed.bind(this);

    this.closeButtons.forEach((button) => button.addEventListener('click', this.close));
    this.forms.forEach((form) => form.addEventListener('submit', this.markDismissed));
  }

  shouldOpen() {
    if (document.documentElement.classList.contains('shopify-design-mode')) return false;
    if (this.readStorage(window.sessionStorage) === 'true') return false;
    if (this.readStorage(window.localStorage) === 'true') return false;
    return true;
  }

  open() {
    this.container.hidden = false;
    this.container.classList.add('is-visible');
    this.container.setAttribute('aria-hidden', 'false');
    document.body.classList.add('language-arrival-popup-open');
    document.addEventListener('keydown', this.handleKeydown);

    window.setTimeout(() => {
      if (this.firstFocusableElement) this.firstFocusableElement.focus();
    }, 0);
  }

  close() {
    this.markDismissed();
    this.container.hidden = true;
    this.container.classList.remove('is-visible');
    this.container.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('language-arrival-popup-open');
    document.removeEventListener('keydown', this.handleKeydown);
  }

  markDismissed() {
    this.writeStorage(window.sessionStorage, 'true');
    this.writeStorage(window.localStorage, 'true');
  }

  readStorage(storage) {
    try {
      return storage.getItem(LANGUAGE_POPUP_STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  writeStorage(storage, value) {
    try {
      storage.setItem(LANGUAGE_POPUP_STORAGE_KEY, value);
    } catch (error) {
      // Ignore browsers that block storage access.
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const popupElement = document.querySelector('[data-language-popup]');
  if (!popupElement) return;

  const popup = new LanguageArrivalPopup(popupElement);
  if (popup.shouldOpen()) {
    popup.open();
  }
});